import { useToast } from '@/components/atoms/Toast';
import type { FilterProps } from '@/components/molecules/Filters';

import { dashboardExportBusinessesRequest } from '@/modules/dashboard/dashboardActions';
import { FilterQueryType } from '@/modules/dashboard/dashboardTypes';
import { useListsDetailsParams } from '@/modules/lists/details/src/hooks/useListsDetailsParams';
import { useUserData } from '@/modules/lists/details/src/hooks/useUserData';
import { sendAnalytics } from '@/services/analyticsService';
import { useDispatch } from 'react-redux';

export const useExportBusinessMutation = ({
	appliedFilters
}: Pick<FilterProps, 'appliedFilters'>) => {
	const { toast } = useToast();
	const dispatch = useDispatch();
	const { user } = useUserData();
	const { listId } = useListsDetailsParams();

	const mutate = (onlyContactedForExport: boolean) => {
		try {
			dispatch(
				dashboardExportBusinessesRequest({
					...(appliedFilters || {}),
					listId,
					limit: 250,
					skip: 0,
					queryType:
						appliedFilters?.queryType !== FilterQueryType.EXPORT
							? FilterQueryType.EXPORT
							: appliedFilters?.queryType,
					queryTypePrev:
						appliedFilters?.queryType ||
						appliedFilters?.queryTypePrev,
					onlyContactedForExport
				})
			);

			toast({
				title: 'Business exported from list, the file will be downloaded to your device soon',
				variant: 'success'
			});

			if (user && user.email) {
				sendAnalytics({
					type: 'track',
					userId: user.email,
					eventName: 'User exported contacted emails from list',
					properties: {
						listId: appliedFilters?.listId
					}
				});
			}
		} catch (error) {
			toast({
				title: 'Something went wrong with business export',
				variant: 'error'
			});
		}
	};

	return { mutate };
};
